import type { SiteConfig, NavItem } from "@/types";

export const siteConfig: SiteConfig = {
  name: "DevStackIO",
  description:
    "Free collection of browser-based developer tools from DevStackIO. JSON formatters, JWT decoders, image compressors, and more — core tools process your content locally.",
  url: process.env.NEXT_PUBLIC_SITE_URL || "https://tools.devstackio.com",
  mainSiteUrl: "https://www.devstackio.com",
  mainSiteName: "DevStackIO",
  ogImage: "/tools-devstackio--preview-card.png",
  links: {
    github: "https://github.com/roddavinod99",
    toolsRepo: "https://github.com/roddavinod99/website.tools",
  },
  contactEmail: process.env.NEXT_PUBLIC_CONTACT_EMAIL || "contact@devstackio.com",
  legal: {
    lastUpdated: {
      privacy: "2026-06-15",
      terms: "2026-06-15",
      cookie: "2026-06-15",
      disclaimer: "2026-06-15",
      security: "2026-07-20",
      accessibility: "2026-08-20",
    },
  },
};

export const mainNav: NavItem[] = [
  { title: "Tools", href: "/tools" },
  { title: "Workflows", href: "/workflows" },
  { title: "Convert", href: "/convert" },
  { title: "Guides", href: "/guides" },
  { title: "Blog", href: "/blog" },
];